import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { Transaction } from "@/entities/ITransaction";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { formatAddress } from "@/helpers/Helpers";
import { TransactionType } from "./UserPageStatsActivityWalletTableRow";
export default function UserPageStatsActivityWalletTableRowMainAddress(t0) {
  const $ = _c(6);
  const {
    transaction,
    type,
    profile
  } = t0;
  let t1;
  if ($[0] !== profile.wallets || $[1] !== transaction || $[2] !== type) {
    const wallet = profile.wallets?.find(w => {
      switch (type) {
        case TransactionType.RECEIVED_AIRDROP:
        case TransactionType.SEIZED:
        case TransactionType.PURCHASE:
        case TransactionType.TRANSFER_IN:
          {
            return w.wallet.toLowerCase() === transaction.to_address.toLowerCase();
          }
        case TransactionType.SALE:
        case TransactionType.BURNED:
        case TransactionType.TRANSFER_OUT:
          {
            return w.wallet.toLowerCase() === transaction.from_address.toLowerCase();
          }
        case TransactionType.RECEIVED_BURN:
        case TransactionType.AIRDROPPED:
        case TransactionType.SEIZED_TO:
          {
            return false;
          }
        default:
          {
            assertUnreachable(type);
            return false;
          }
      }
    });
    const getWalletDisplay = () => {
      if (type === TransactionType.RECEIVED_BURN || type === TransactionType.AIRDROPPED || type === TransactionType.SEIZED_TO) {
        return "Null Address";
      }
      if (!wallet) {
        return "unknown";
      }
      return wallet.display ?? formatAddress(wallet.wallet);
    };
    t1 = getWalletDisplay();
    $[0] = profile.wallets;
    $[1] = transaction;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const walletDisplay = t1;
  let t2;
  if ($[4] !== walletDisplay) {
    t2 = <span className="tw-text-sm sm:tw-text-base tw-text-iron-100 tw-font-medium">{walletDisplay}</span>;
    $[4] = walletDisplay;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}